<template>
  <div class="app-container">
    <el-form :inline="false" label-position="top" size="small">
      <el-row :gutter="20">
        <el-col :span="5">
          <!--  运单号   -->
          <el-form-item>
            <template slot="label">
              <div class="selectLabel">
                <el-select v-model="queryForm.params.selectType">
                  <el-option key="1" :label="$t('GlobalSetObj.bagNumber')" :value="1" />
                  <el-option key="2" :label="$t('GlobalSetObj.licensePlateNumber')" :value="2" />
                </el-select>
              </div>
            </template>
            <el-input
              v-model="queryForm.params.inputValue"
              :placeholder="$t('newOrder.PreciseSearch1')"
              :rows="1"
              style="width: 100%"
              type="textarea"
            />
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <!-- 操作类型  -->
          <el-form-item :label="$t('collectionCenter.operationType')">
            <el-select
              v-model="queryForm.params.operationType"
              :placeholder="$t('GlobalSetObj.pleaseChoose')"
              clearable
              style="width: 100%"
            >
              <el-option key="1" :label="$t('routes.sorterConsolidation')" :value="1" />
              <el-option key="2" :label="$t('routes.manualConsolidation')" :value="2" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <!-- 业务类型  -->
          <el-form-item :label="$t('navbar.businessType')">
            <el-select
              v-model="queryForm.params.businessType"
              :placeholder="$t('GlobalSetObj.pleaseChoose')"
              clearable
              style="width: 100%"
            >
              <el-option key="1" :label="$t('routes.forwardConsolidation')" :value="1" />
              <el-option key="2" :label="$t('routes.returnConsolidation')" :value="2" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <!--时间-->
          <el-form-item prop="timeType">
            <template slot="label">
              <div class="selectLabel">
                <el-select v-model="queryForm.params.timeType" :style="IsWidth">
                  <el-option
                    v-for="item in timeLable"
                    :key="item.id"
                    :label="item.label"
                    :value="item.id"
                  />
                </el-select>
              </div>
            </template>
            <el-date-picker
              v-model="timeValue"
              :clearable="false"
              :default-time="['00:00:00', '23:59:59']"
              :format="$i18n.locale == 'zh' ? zhDate : ptDate"
              :placeholder="$t('newOrder.SelectDatetime')"
              range-separator="~"
              style="width: 100%"
              type="datetimerange"
              value-format="yyyy-MM-dd HH:mm:ss"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="5">
          <!--  集包操作网点  -->
          <el-form-item :label="$t('routes.consolidationOperationHub')">
            <el-select
              v-model="queryForm.params.operationSiteId"
              :placeholder="$t('GlobalSetObj.pleaseChoose')"
              :remote-method="remoteGetSiteList"
              clearable
              filterable
              remote
              reserve-keyword
              style="width: 100%"
              @focus="remoteGetSiteList('')"
            >
              <el-option
                v-for="item in preDeliverySiteList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <div style="margin-top: 28px">
            <!--搜索-->
            <el-button
              icon="el-icon-search" size="small" type="primary"
              @click="enterSearch"
            >{{ $t('newOrder.search') }}
            </el-button>
            <!--重置-->
            <el-button
              icon="el-icon-refresh-left" size="small" type="info"
              @click="resetForm()"
            >{{ $t('newOrder.reset') }}
            </el-button>
            <el-button
              size="small" type="success" @click="allExportOrder(1)"
            >{{ $t('collectionCenter.export1') }}
            </el-button>
            <el-button
              size="small" type="success" @click="allExportOrder(2)"
            >{{ $t('collectionCenter.allExport') }}
            </el-button>
          </div>
        </el-col>
      </el-row>
    </el-form>
    <!--  表格数据  -->
    <el-table
      ref="tableRef"
      :data="tableData"
      :header-cell-style="{ background: '#f2f2f2', color: 'black' }"
      border
      row-key="id"
      style="width: 100%"
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        :reserve-selection="true"
        align="center"
        fixed="left"
        type="selection"
        width="50"
      />
      <el-table-column
        :label="$t('GlobalSetObj.serial')" align="center" type="index"
        width="80"
      />
      <el-table-column
        v-for="item in tableHeaderList"
        :key="item.id"
        :align="item.center"
        :label="item.label"
        :min-width="item.cloWidth"
        :prop="item.prop"
        :show-overflow-tooltip="false"
      >
        <template slot-scope="scope">
          <div
            v-if="item.prop === 'packageCount'"
            class="textOperator"
            @click="handlePackageDetail(scope.row)"
          >
            {{ scope.row.packageCount || 0 }}
          </div>
          <div v-else>{{ scope.row[item.prop] ? `${scope.row[item.prop]}` : '--' }}</div>
        </template>
      </el-table-column>
    </el-table>
    <!--  分页  -->
    <el-pagination
      :current-page="queryForm.pageNumber"
      :page-size="queryForm.pageSize"
      :page-sizes="[10, 20, 50, 100]"
      :total="queryForm.total"
      background
      layout="total, sizes, prev, pager, next, jumper"
      style="margin: 10px 0; float: right"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
    <packageDetail ref="packageDetailRef" :dataobj="{}" />
  </div>
</template>

<script>
import dayjs from 'dayjs';
import { siteFuzzyQuery } from '@/api/lanshou';
import { goResourceTaskList } from '@/utils/goExportList';
import { baggingOperationExportAll, baggingOperationPage } from '@/api/newExpressAPI';

export default {
  name: 'PackingOperationRecord',
  components: {
    packageDetail: () => import('./component/packageDetail')
  },
  data() {
    return {
      // 是否格式化成巴西时间
      isTormat: false,
      zhDate: 'yyyy-MM-dd HH:mm:ss',
      ptDate: 'dd-MM-yyyy HH:mm:ss',
      timeValue: [],
      selectList: [],
      queryForm: {
        pageSize: 10,
        pageNumber: 1,
        total: 0,
        params: {
          timeType: 1,
          selectType: 1,
          operationType: '',
          businessType: '',
          operationSiteId: '',
          inputValue: ''
        }
      },
      tableData: [],
      preDeliverySiteList: [],
      tableHeaderList: [
        // 袋号
        {
          id: 1,
          label: this.$t('GlobalSetObj.bagNumber'),
          prop: 'bagNumber',
          cloWidth: '150',
          center: 'center'
        },
        // 操作类型
        {
          id: 2,
          label: this.$t('collectionCenter.operationType'),
          prop: 'operationType',
          cloWidth: '140',
          center: 'center'
        },
        // 业务类型
        {
          id: 3,
          label: this.$t('navbar.businessType'),
          prop: 'businessType',
          cloWidth: '140',
          center: 'center'
        },
        // 包裹数量
        {
          id: 4,
          label: this.$t('mdfeTranslate.QuantityOfPackages'),
          prop: 'packageCount',
          cloWidth: '140',
          center: 'center'
        },
        // 集包时间
        {
          id: 5,
          label: this.$t('routes.CollectionTime'),
          prop: 'baggingTime',
          cloWidth: '160',
          center: 'center'
        },
        // 集包操作网点
        {
          id: 6,
          label: this.$t('routes.consolidationOperationHub'),
          prop: 'operationSiteName',
          cloWidth: '160',
          center: 'center'
        },
        // 装车完成时间-1
        {
          id: 7,
          label: this.$t('routes.loadingCompletionTime1'),
          prop: 'loadTime0',
          cloWidth: '160',
          center: 'center'
        },
        // 车牌号
        {
          id: 8,
          label: this.$t('routes.licensePlateNumber1'),
          prop: 'vehicleNumber0',
          cloWidth: '160',
          center: 'center'
        },
        // 下一站
        {
          id: 9,
          label: this.$t('routes.nextStation1'),
          prop: 'nextSiteName0',
          cloWidth: '160',
          center: 'center'
        },
        // 卸车时间
        {
          id: 10,
          label: this.$t('routes.unloadingTime1'),
          prop: 'unloadTime0',
          cloWidth: '160',
          center: 'center'
        },
        // 装车完成时间-1
        {
          id: 11,
          label: this.$t('routes.loadingCompletionTime2'),
          prop: 'loadTime1',
          cloWidth: '160',
          center: 'center'
        },
        // 车牌号
        {
          id: 12,
          label: this.$t('routes.licensePlateNumber2'),
          prop: 'vehicleNumber1',
          cloWidth: '160',
          center: 'center'
        },
        // 下一站
        {
          id: 13,
          label: this.$t('routes.nextStation2'),
          prop: 'nextSiteName1',
          cloWidth: '160',
          center: 'center'
        },
        // 卸车时间
        {
          id: 14,
          label: this.$t('routes.unloadingTime2'),
          prop: 'unloadTime1',
          cloWidth: '160',
          center: 'center'
        },
        // 装车完成时间-3
        {
          id: 15,
          label: this.$t('routes.loadingCompletionTime3'),
          prop: 'loadTime2',
          cloWidth: '160',
          center: 'center'
        },
        // 车牌号
        {
          id: 16,
          label: this.$t('routes.licensePlateNumber3'),
          prop: 'vehicleNumber2',
          cloWidth: '160',
          center: 'center'
        },
        // 下一站
        {
          id: 18,
          label: this.$t('routes.nextStation3'),
          prop: 'nextSiteName2',
          cloWidth: '160',
          center: 'center'
        },
        // 卸车时间
        {
          id: 17,
          label: this.$t('routes.unloadingTime3'),
          prop: 'unloadTime2',
          cloWidth: '160',
          center: 'center'
        }
      ],
      customerList: [], // 用户列表
      timeLable: [
        { id: 1, label: this.$t('routes.CollectionTime') },
        { id: 2, label: this.$t('routes.loadingCompletionTime') },
        { id: 3, label: this.$t('GlobalSetObj.unCarTime') }
      ]
    };
  },
  computed: {
    IsWidth() {
      return {
        width: this.isTormat ? '250px' : '160px'
      };
    },
    IsWidth1() {
      return {
        width: this.isTormat ? '180px' : '160px'
      };
    }
  },
  created() {
    if (this.$i18n.locale !== 'zh') {
      this.isTormat = true;
    }
    this.getTimer();
    this.getSearch(1);
    this.remoteGetSiteList('');
  },
  methods: {
    handlePackageDetail(row) {
      this.$refs.packageDetailRef.showDetail(row);
    },
    // 查询
    getSearch(val) {
      let inputValList = [];
      if (this.queryForm.params.inputValue) {
        // 单号格式化，去除空格
        const orderNumber = this.queryForm.params.inputValue.split(/[(\r\n)\r\n]+/);
        orderNumber.map((item) => {
          if (item) {
            inputValList.push(item.trim());
          }
        });
      }
      if (inputValList.length > 2000) {
        this.$message.warning(this.$t('newOrder.searchMax1000'));
        inputValList = inputValList.slice(0, 2000); // 截取前2000个单号
      }
      const data = {
        params: {
          baggingTimeStart: '',
          baggingTimeEnd: '',
          loadTimeStart: '',
          loadTimeEnd: '',
          unloadTimeStart: '',
          unloadTimeEnd: '',
          bagNumberList: [],
          vehicleNumberList: []
        }
      };
      data.pageSize = this.queryForm.pageSize;
      data.pageNumber = this.queryForm.pageNumber;
      data.params = { ...this.queryForm.params };
      if (this.timeValue && this.timeValue.length > 0) {
        if (this.queryForm.params.timeType === 1) {
          data.params.baggingTimeStart = this.timeValue[0];
          data.params.baggingTimeEnd = this.timeValue[1];
        } else if (this.queryForm.params.timeType === 2) {
          data.params.loadTimeStart = this.timeValue[0];
          data.params.loadTimeEnd = this.timeValue[1];
        } else {
          data.params.unloadTimeStart = this.timeValue[0];
          data.params.unloadTimeEnd = this.timeValue[1];
        }
      }
      if (this.queryForm.params.selectType === 1) {
        data.params.bagNumberList = inputValList;
      } else {
        data.params.vehicleNumberList = inputValList;
      }
      let loading = null;
      if (val === 1) {
        loading = this.$loading({
          fullscreen: true,
          lock: true,
          spinner: 'el-icon-loading',
          text: 'loading...',
          background: 'rgba(250, 250, 250, 0.6)'
        });
      }
      baggingOperationPage(data).then((res) => {
        if (res.code === 200) {
          if (val === 1) {
            loading.close();
          }
          this.queryForm.total = res.data.total;
          this.tableData = res.data.records;
          this.tableData.forEach((item, index) => {
            try {
              if (item.transportRecords && item.transportRecords.length) {
                item.transportRecords.forEach((item2, index2) => {
                  const keyStr1 = 'loadTime' + index2;
                  const keyStr2 = 'vehicleNumber' + index2;
                  const keyStr3 = 'nextSiteName' + index2;
                  const keyStr4 = 'unloadTime' + index2;
                  item[keyStr1] = item2.loadTime || '--';
                  item[keyStr2] = item2.vehicleNumber || '--';
                  item[keyStr3] = item2.nextSiteName || '--';
                  item[keyStr4] = item2.unloadTime || '--';
                });
              }
            } catch (error) {
              if (val === 1) {
                loading.close();
              }
              console.log(error);
            }
          });
        }
      });
    },
    allExportOrder(flag) {
      let data = {
        baggingTimeStart: '',
        baggingTimeEnd: '',
        loadTimeStart: '',
        loadTimeEnd: '',
        unloadTimeStart: '',
        unloadTimeEnd: '',
        bagNumberList: [],
        vehicleNumberList: []
      };
      let inputValList = [];
      if (flag === 2) {
        if (this.queryForm.params.inputValue) {
          inputValList = this.queryForm.params.inputValue.split('\n');
        }
        if (inputValList.length > 2000) {
          this.$message.warning(this.$t('newOrder.searchMax1000'));
          inputValList = inputValList.slice(0, 2000); // 截取前2000个单号
        }
        data = { ...this.queryForm.params };
        if (this.timeValue && this.timeValue.length > 0) {
          if (this.queryForm.params.timeType === 1) {
            data.baggingTimeStart = this.timeValue[0];
            data.baggingTimeEnd = this.timeValue[1];
          } else if (this.queryForm.params.timeType === 2) {
            data.loadTimeStart = this.timeValue[0];
            data.loadTimeEnd = this.timeValue[1];
          } else {
            data.unloadTimeStart = this.timeValue[0];
            data.unloadTimeEnd = this.timeValue[1];
          }
        }
        if (this.queryForm.params.selectType === 1) {
          data.bagNumberList = inputValList;
        } else {
          data.vehicleNumberList = inputValList;
        }
      } else {
        if (this.selectList.length > 0) {
          this.selectList.forEach((item) => {
            data.bagNumberList.push(item.bagNumber);
          });
        } else {
          this.$message.error(this.$t('collectionCenter.checkMsg'));
          return;
        }
      }
      baggingOperationExportAll(data).then((res) => {
        if (res.code === 200) {
          this.$refs.tableRef.clearSelection();
          goResourceTaskList();
        }
      });
    },
    // 获取最近一周时间
    getTimer() {
      // 获取当前时间
      const today = dayjs().format('YYYY-MM-DD');
      const oneWeekAgo = dayjs().subtract(1, 'months').format('YYYY-MM-DD');
      this.timeValue = [oneWeekAgo + ' 00:00:00', today + ' 23:59:59'];
    },
    enterSearch() {
      this.queryForm.pageNumber = 1;
      this.getSearch();
    },
    // 重置
    resetForm() {
      this.queryForm.pageNumber = 1;
      this.getTimer();
      this.queryForm.params = {
        timeType: 1,
        selectType: 1,
        operationType: '',
        businessType: '',
        operationSiteId: '',
        inputValue: ''
      };
      this.getSearch();
    },
    // 获取所有网点
    remoteGetSiteList(val) {
      const value = val || '';
      siteFuzzyQuery(value).then((res) => {
        if (res.code === 200) {
          this.preDeliverySiteList = res.data;
        }
      });
    },
    // 点击分页
    handleSizeChange(val) {
      this.queryForm.pageSize = val;
      this.queryForm.pageNumber = 1;
      this.getSearch();
    },
    handleCurrentChange(val) {
      this.queryForm.pageNumber = val;
      this.getSearch();
    },
    handleSelectionChange(val) {
      this.selectList = val;
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep {
  .drawerClass header {
    border-bottom: 1px solid #aaa !important;
    margin-bottom: 0 !important;
    padding: 20px 20px 20px !important;
  }
}

.selectLabel ::v-deep .el-input__inner {
  height: 28px !important;
  line-height: 28px !important;
  font-weight: bold;
  text-align: left;
  margin-bottom: 5px;
}

.textOperator {
  color: #409eff;
  cursor: pointer;
}

.textOperator1 {
  color: #f56c6c;
  cursor: pointer;
  font-size: 22px;
}

.messgeList {
  height: 450px;
  background-color: #f5f5f5;
  margin-bottom: 20px;
  border-radius: 10px;
  padding: 10px;
  overflow-y: auto;
}

.downLink {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #f5f7fa;
  cursor: pointer;
  padding: 5px;
}

.downModule {
  color: #409eff;
  text-decoration: underline;
  cursor: pointer;
  margin-right: 15px;
}
</style>
